import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Grid,
  Stack,
  Divider,
  Tabs,
  Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import StarIcon from "@mui/icons-material/Star";
import FiveSlotSymbolIcon from "./FiveSlotSymbolIcon";
import {
  FIAT_SET_SYMBOLS,
  CRYPTO_SET_SYMBOLS,
  JACKPOT_DEFAULTS,
} from "./fiveSlotConfig";

export const FiveSlotPaytableModal = ({
  open,
  onClose,
  activeCategory = "fiat",
  currency = "BET",
}) => {
  const [selectedTab, setSelectedTab] = useState(activeCategory === "crypto" ? "crypto" : "fiat");

  const currentSymbols = selectedTab === "crypto" ? CRYPTO_SET_SYMBOLS : FIAT_SET_SYMBOLS;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          background: "#ffffff",
          bgcolor: "#ffffff",
          border: "1px solid #e2e8f0",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.12)",
          color: "#0f172a",
          p: { xs: 1, sm: 2 },
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e2e8f0",
          pb: 1.5,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              p: "6px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #3b82f6, #2563eb)",
              display: "flex",
            }}
          >
            <EmojiEventsIcon sx={{ color: "#ffffff", fontSize: 24 }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 900,
                color: "#0f172a",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                lineHeight: 1.2,
              }}
            >
              PAYTABLE & WINNING LOGIC (5 REELS)
            </Typography>
            <Typography variant="caption" sx={{ color: "#64748b" }}>
              5-Reel Progressive Slot • Center Payline • 7-Symbol Editions
            </Typography>
          </Box>
        </Stack>
        <IconButton onClick={onClose} sx={{ color: "#64748b", "&:hover": { color: "#0f172a", bgcolor: "#f1f5f9" } }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 2, px: { xs: 1, sm: 2 } }}>
        {/* TAB SELECTOR: FIAT VS CRYPTO */}
        <Box sx={{ mb: 2.5, display: "flex", justifyContent: "center" }}>
          <Tabs
            value={selectedTab}
            onChange={(e, val) => setSelectedTab(val)}
            sx={{
              bgcolor: "#f1f5f9",
              p: "4px",
              borderRadius: "14px",
              border: "1px solid #e2e8f0",
              "& .MuiTabs-indicator": { display: "none" },
            }}
          >
            <Tab
              value="fiat"
              label="Classic Vegas Symbols"
              sx={{
                color: selectedTab === "fiat" ? "#0f172a !important" : "#64748b",
                bgcolor: selectedTab === "fiat" ? "#ffffff !important" : "transparent",
                background: selectedTab === "fiat" ? "#ffffff" : "transparent",
                boxShadow: selectedTab === "fiat" ? "0 2px 6px rgba(0, 0, 0, 0.08)" : "none",
                borderRadius: "10px",
                fontWeight: 800,
                fontSize: "0.85rem",
                textTransform: "none",
                minHeight: "36px",
                px: 2.5,
              }}
            />
            <Tab
              value="crypto"
              label="Crypto Slot Symbols"
              sx={{
                color: selectedTab === "crypto" ? "#0f172a !important" : "#64748b",
                bgcolor: selectedTab === "crypto" ? "#ffffff !important" : "transparent",
                background: selectedTab === "crypto" ? "#ffffff" : "transparent",
                boxShadow: selectedTab === "crypto" ? "0 2px 6px rgba(0, 0, 0, 0.08)" : "none",
                borderRadius: "10px",
                fontWeight: 800,
                fontSize: "0.85rem",
                textTransform: "none",
                minHeight: "36px",
                px: 2.5,
              }}
            />
          </Tabs>
        </Box>

        {/* PROGRESSIVE JACKPOT TIERS */}
        <Box sx={{ mb: 3 }}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
            <StarIcon sx={{ color: "#f59e0b", fontSize: 20 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#0f172a" }}>
              PROGRESSIVE JACKPOT POOLS (5-OF-A-KIND)
            </Typography>
          </Stack>
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",
                  border: "1.5px solid #fca5a5",
                  boxShadow: "0 2px 8px rgba(239, 68, 68, 0.12)",
                  textAlign: "center",
                }}
              >
                <Typography variant="caption" sx={{ color: "#dc2626", fontWeight: 800, display: "block" }}>
                  👑 MEGA JACKPOT
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 900, color: "#991b1b" }}>
                  {currency} {JACKPOT_DEFAULTS.mega.toLocaleString()}
                </Typography>
                <Typography variant="caption" sx={{ color: "#64748b", fontSize: "0.7rem" }}>
                  5x {selectedTab === "crypto" ? "Bitcoin (BTC)" : "Royal Crown"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)",
                  border: "1.5px solid #d8b4fe",
                  boxShadow: "0 2px 8px rgba(168, 85, 247, 0.12)",
                  textAlign: "center",
                }}
              >
                <Typography variant="caption" sx={{ color: "#7c3aed", fontWeight: 800, display: "block" }}>
                  💎 MAJOR JACKPOT
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 900, color: "#581c87" }}>
                  {currency} {JACKPOT_DEFAULTS.major.toLocaleString()}
                </Typography>
                <Typography variant="caption" sx={{ color: "#64748b", fontSize: "0.7rem" }}>
                  5x {selectedTab === "crypto" ? "Ethereum (ETH)" : "Brilliant Diamond"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #fefce8 0%, #fef9c3 100%)",
                  border: "1.5px solid #fde047",
                  boxShadow: "0 2px 8px rgba(234, 179, 8, 0.12)",
                  textAlign: "center",
                }}
              >
                <Typography variant="caption" sx={{ color: "#ca8a04", fontWeight: 800, display: "block" }}>
                  🔔 MINI JACKPOT
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 900, color: "#854d0e" }}>
                  {currency} {JACKPOT_DEFAULTS.mini.toLocaleString()}
                </Typography>
                <Typography variant="caption" sx={{ color: "#64748b", fontSize: "0.7rem" }}>
                  5x {selectedTab === "crypto" ? "Polygon POL" : "Golden Bell"}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ borderColor: "#e2e8f0", my: 2.5 }} />

        {/* 7 ACTIVE SYMBOLS & PAYOUT DETAILS */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#0f172a", mb: 1.5 }}>
            7 SYMBOL WINNING TIERS (3x, 4x, 5x MATCHES)
          </Typography>
          <Grid container spacing={1.5}>
            {currentSymbols.map((sym) => (
              <Grid item xs={12} sm={6} key={sym.id}>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: "14px",
                    background: "#f8fafc",
                    border: `1.5px solid #e2e8f0`,
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    height: "100%",
                    transition: "border-color 0.15s ease",
                    "&:hover": {
                      borderColor: sym.tierColor || "#3b82f6",
                    },
                  }}
                >
                  <FiveSlotSymbolIcon symbol={sym} size="sm" />
                  <Box sx={{ flex: 1 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#0f172a" }}>
                        {sym.label}
                      </Typography>
                      <Box
                        sx={{
                          px: 1,
                          py: "2px",
                          borderRadius: "6px",
                          bgcolor: `${sym.tierColor}18`,
                          border: `1px solid ${sym.tierColor}55`,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ color: sym.tierColor, fontWeight: 900, fontSize: "0.68rem" }}
                        >
                          {sym.tier || sym.winningTier}
                        </Typography>
                      </Box>
                    </Stack>
                    {sym.winOutcome && sym.winOutcome !== sym.winningTier && sym.winOutcome !== sym.tier && (
                      <Typography variant="caption" sx={{ color: sym.tierColor || "#2563eb", fontWeight: 800, display: "block" }}>
                        {sym.winOutcome}
                      </Typography>
                    )}
                    <Typography variant="caption" sx={{ color: "#64748b", fontSize: "0.72rem", lineHeight: 1.2 }}>
                      {sym.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: "10px",
            background: "#eff6ff",
            border: "1px dashed #93c5fd",
            textAlign: "center",
          }}
        >
          <Typography variant="caption" sx={{ color: "#1e40af", fontWeight: 700 }}>
            💡 Match 3, 4, or 5 identical symbols on the center payline to trigger Progressive Jackpots or Free Spins!
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FiveSlotPaytableModal;
